export enum GlPlanModeEnum {
  ACTIVE = 'ACTIVE',
  EDIT = 'EDIT',
  // TEMPLATE = 'TEMPLATE',
  // DELETED = 'DELETED',
}
